import axios from "axios";

export const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

const authInterceptor = (config) => {
  config.headers["Content-Type"] = "application/json";
  config.headers["Client"] = "web-app-cli";
  return config;
};

const successInterceptor = (response) => {
  return response;
};

const errorInterceptor = (error) => {
  if (error?.response?.status) {
    // eslint-disable-next-line default-case
    switch (error.response.status) {
      case 401:
        const { url } = error.config;
        if (url === "/auth/sign-in/keycloak") return;
        else {
          console.log("Su sesión ha terminado");
          setTimeout(() => {
            localStorage.clear();
            // document.location.reload();
          }, 2000);
        }
    }
  }
  return Promise.reject(error);
};

httpClient.interceptors.request.use(authInterceptor);
httpClient.interceptors.response.use(successInterceptor, errorInterceptor);
